<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1 v-if="eventData">Ocena dogodka "{{eventData.name}}"</h1>
            </div>
        </div>



        <div class="row mt-0 mt-md-5 mb-5">
            <div class="col-md-4 my-3">
              <a @click="vote(1)" class="card voteBtn" :class="lastVote === 1 ? 'active': ''">
                <b-card-body class="text-center">
                  <i class="far fa-frown fa-3x"></i>
                  <h4 class="mt-3 text-muted font-weight-light">Nezadovoljen</h4>
                </b-card-body>
              </a>
            </div>

          <div class="col-md-4 my-3">
            <a @click="vote(2)" class="card voteBtn" :class="lastVote === 2 ? 'active': ''">
              <b-card-body class="text-center">
                <i class="far fa-meh fa-3x"></i>
                <h4 class="mt-3 text-muted font-weight-light">Srednje zadovoljen</h4>
              </b-card-body>
            </a>
          </div>

          <div class="col-md-4 my-3">
            <a @click="vote(3)" class="card voteBtn" :class="lastVote === 3 ? 'active': ''">
              <b-card-body class="text-center">
                <i class="far fa-smile fa-3x"></i>
                <h4 class="mt-3 text-muted font-weight-light">Zelo zadovoljen</h4>
              </b-card-body>
            </a>
          </div>
        </div>


    </div>
</template>

<script>
  import Vue from 'vue';
  import firebase from 'firebase'
  import {db} from '../main'
  import {VueGoodTable} from 'vue-good-table'
  import 'vue-good-table/dist/vue-good-table.css'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import _ from "lodash";

  export default {
    name: 'EventEvaluationVote',
    components: {
      VueGoodTable,
      vSelect,
    },
    data () {
      return {
        id: this.$route.params.id,
        eventData: null,
        activeClass: null,
        lastVote: null
      }
    },
    mounted () {
      const _this = this

      if (_this.$store.getters.getProjects.length === 0) {
        _this.$store.dispatch('retrieveProjects').then(() => {
          _this.projects = _this.$store.getters.getProjects
        })
      }

      if (_this.$store.getters.getUsers.length === 0) {
        _this.$store.dispatch('retrieveUsers').then(() => {
          _this.users = _this.$store.getters.getUsers
        })
      }


      _this.loadEvent();


    },
    methods: {
      loadEvent () {
        const _this = this

        db.collection('eventEvaluation')
            .doc(_this.id)
            .get()
            .then(snapshot => {
              const document = snapshot.data()

              _.forOwn(document, function (value, key) {
                if (key === 'date') {
                  document[key] = value ? _this.moment.unix(value.seconds).format('YYYY-MM-DDTHH:mm:ssZ') : null
                } else if (key === 'address') {
                  _this.$refs.autocomplete.$refs.input.value = value // manually set init GmapAutocomplete value
                  console.log(_this.$refs.autocomplete)
                }
              })

              _this.eventData = document
              console.log("this.event", _this.event);

            })

      },

      vote(score) {
        const _this = this

        _this.lastVote = score;

        setTimeout(() => {
          _this.lastVote = null;
        },1000);

        const voteRecord = {
          score: score,
          votedAt: firebase.firestore.Timestamp.now()
        };

        const eventEvaluations = db.collection("eventEvaluation").doc(_this.id);

        return db
            .runTransaction(t => {
              return t.get(eventEvaluations).then(doc => {
                // doc doesn't exist; can't update
                if (!doc.exists) return;

                // update the users array after getting it from Firestore.
                const newVoteArray = _.concat(doc.get("votes"), [voteRecord]);
                t.set(eventEvaluations, { votes: newVoteArray }, { merge: true });
                _this.eventData.votes = newVoteArray;

                Vue.$toast.open({ message: 'Glas uspešno oddan!', position: 'top', type: 'info'});
              });
            })
            .catch(console.log);
      }
    },
  }
</script>
<style type="text/css">
  .voteBtn {
    transition: all 0.2s;
    background-color: none;
    color: #6c757d !important;
    cursor: pointer !important;
  }
  .voteBtn:hover {
    text-decoration: none;
  }
  .voteBtn h4,
  .voteBtn i {
    color: #6c757d !important;
    cursor: pointer !important;
  }
  .voteBtn.active {
    background-color: #effcef;
    cursor: pointer !important;
  }
  .voteBtn.active h4,
  .voteBtn.active i {
    color: #35A31F !important;
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/EventEvaluationVote.vue